import React from 'react';
import { ChevronRight, Home } from 'lucide-react';
import { HierarchyNode } from '../types';
import { cn } from '../utils/cn';

interface BreadcrumbNavProps {
  path: HierarchyNode[];
  onNavigate: (index: number) => void;
  className?: string;
}

export const BreadcrumbNav: React.FC<BreadcrumbNavProps> = ({ 
  path, 
  onNavigate,
  className 
}) => {
  return (
    <nav className={cn("flex items-center space-x-2 mb-6 text-sm", className)}>
      <button
        onClick={() => onNavigate(-1)}
        className="flex items-center text-gray-600 hover:text-gray-900 transition-colors"
      >
        <Home className="w-4 h-4 mr-1" />
        <span>All Tutorials</span>
      </button>
      
      {path.map((node, index) => (
        <React.Fragment key={node.id}>
          <ChevronRight className="w-4 h-4 text-gray-400" />
          <button
            onClick={() => onNavigate(index)}
            className="text-gray-600 hover:text-gray-900 transition-colors truncate max-w-[200px]"
            title={node.name}
          >
            {node.name}
          </button>
        </React.Fragment>
      ))}
    </nav>
  );
};

